const lbaFileDownloader = angular.module('app.lbaFileDownloader', []);

lbaFileDownloader.controller('lbaFileDownloaderCtrl', require('./lbaFileDownloaderCtrl'));
lbaFileDownloader.directive('lbaFileDownloader', require('./lbaFileDownloaderDir'));

export default lbaFileDownloader;



// WEBPACK FOOTER //
// ./src/components/lbaFileDownloader/index.js